import { Button, BUTTON_THEME, Icon } from '@st-operations/uikit/src/v2'
import React, { useState, useMemo } from 'react'
import { useEffect } from 'react'

import MultiValueInput from '_components/multi-value-input/index.jsx'
import { getEventsSchema } from '_services/data-explorer.js'
import useTotalUsers from '../hooks/useTotalUsers'
import MonthlyUserCount from '../monthly-user-count'

import './styles.scss'

const EventFeedsWizardAttributes = ({
  onBackClick,
  attributes,
  onAttributesChange,
  onSkip,
  onAddAttributes,
  cumulativeFilters,
}) => {
  const payload = useMemo(() => ({ filters: cumulativeFilters }), [cumulativeFilters])
  const [totalUsers] = useTotalUsers(payload)

  const [schema, setSchema] = useState()
  useEffect(() => {
    getEventsSchema().then((schemaData) => {
      setSchema(schemaData)
    })
  }, [])

  const normalizedOptions = useMemo(
    () =>
      schema?.attributes &&
      Object.values(schema?.attributes)
        .filter((val) => typeof val !== 'string' && !Array.isArray(val))
        .map((val) =>
          Object.keys(val).map((valKey, index) => ({
            label: Object.values(val)?.[index]?.label || valKey,
            value: valKey,
          }))
        )
        .flat(),
    [schema]
  )

  return (
    <div className="event-feeds-wizard-attribute__container">
      <Button
        theme={BUTTON_THEME.GHOST}
        onClick={onBackClick}
        className="event-feeds-wizard-attribute__back-button"
      >
        <Icon type="outline" icon="angleleft" />
        Back
      </Button>
      <span className="event-feeds-wizard-attribute__title">{`5. My feed should have these attributes:`}</span>
      <MultiValueInput
        name="value"
        className="event-feeds-wizard-attribute__input"
        values={attributes}
        onChange={onAttributesChange}
        options={normalizedOptions}
      />
      <MonthlyUserCount totalUsers={totalUsers} />
      <Button
        theme={BUTTON_THEME.GHOST}
        onClick={() => {
          onAttributesChange([])
          onSkip()
        }}
      >
        Skip
      </Button>
      <div className="event-feeds-wizard-attribute__add-terms-container">
        <Button
          className="event-feeds-wizard-attribute__add-terms-button"
          disabled={attributes.length === 0}
          onClick={onAddAttributes}
        >
          Add Attributes
        </Button>
      </div>
    </div>
  )
}

export default EventFeedsWizardAttributes
